export default __webpack_public_path__ + "static/media/CNo.15-1.469d7623.jpg";